/*
Controller for editing the business info
 */
angular.module('qkr').controller('businessEditController', ($scope, $rootScope, $routeSegment, systemSettingsService,
                                                            businessService, merchantService, messageService,
                                                            imageService, FormHelper, utils, gettextCatalog) => {
    $scope.$routeSegment = $routeSegment;    // Used to know what we've selected
    $scope.countries = [];
    $scope.currencies = [];
    $scope.timezones = [];
    $scope.saving = false;
    $scope.merchantInfoLoaded = false;
    // Help with errors and validation
    const formHelper = new FormHelper($scope);
    
    // Called on initialisation of the view
    $scope.init = function() {
        $scope.$routeSegment = $routeSegment;    // Used to know what we've selected

        $scope.form = {};

        merchantService.loadMerchantInfo().then((promise) => {
            if (promise.businessCategory.name === 'School') {
                $scope.businessType = 'school';
                $scope.capBusinessType = 'School';
            } else if (promise.businessCategory.name === 'University') {
            	$scope.businessType = 'university';
              	$scope.capBusinessType = 'University';
            } else {
            	$scope.businessType = 'business';
                $scope.capBusinessType = 'business';
            }
        	
            $scope.merchantInfoLoaded = true;
            $scope.form.contactDetails = angular.copy(promise.contactDetails);
            $scope.form.timezoneId = promise.supportedTimeZone.id;
            $scope.form.coverImage = imageService.fullImageUrl(promise.imageUrl);
            $scope.form.description = promise.description;
            $scope.form.logo = imageService.fullImageUrl(promise.imageUrl);

			$scope.form.countryId = promise.contactDetails.country.id;

            systemSettingsService.loadCountry($scope.form.countryId).then((promise) => {
            	$scope.country = promise;
            	$scope.timezones = $scope.country.timezones;
            	$scope.currency = $scope.country.currency;
				$scope.form.currencyId = $scope.currency.id;
  			});
        });
    },
    
    $scope.validateForm = function() {
        // Empty the errors list
        $scope.errors = null;
        let valid = true;
        const errors = {};

        // Check for mandatory fields. Country and currency are locked
/*        If(utils.hasNoValue($scope.form.inputCountry))
        {
            errors.country = "Country must be selected";
            valid = false;
        }
        if(utils.hasNoValue($scope.form.currencyId))
        {
            errors.currency = "Currency must be selected";
            valid = false;
        }
*/
        if (utils.hasNoValue($scope.form.timezoneId)) {
            errors.timezone = gettextCatalog.getString('Timezone must be selected');
            valid = false;
        }
        $scope.errors = errors;

        return valid;
    },

    $scope.saveBusinessSettings = function() {
        if (!$scope.validateForm()) {
            return;
        }

        for (var a = 0; a < $scope.currencies.length; a++) {
            if ($scope.currencies[a].id === $scope.form.currencyId) {
               $scope.form.currency = $scope.currencies[a];
            }
        }
        let foundTimezone = false;
        for (var a = 0; a < $scope.timezones.length; a++) {
            if ($scope.timezones[a].id === $scope.form.timezoneId) {
                $scope.form.supportedTimeZone = $scope.timezones[a];
                foundTimezone = true;
            }
        }
        if (!foundTimezone)
            $scope.form.supportedTimeZone = {id: $scope.form.timezoneId};
        if (utils.hasNoValue($scope.form.contactDetails))
            $scope.form.contactDetails = {};
        if (utils.hasNoValue($scope.form.contactDetails.country))
            $scope.form.contactDetails.country = {};

        $scope.form.contactDetails.country.id = $scope.form.inputCountry;

        businessService.updateBusiness($scope.form).then((promise) => {
            $scope.updateBusinessCallback(promise);
        }, (promise) => {
            $scope.updateBusinessCallback(promise);
        });

        // Show the spinner
        $scope.saving = true;
    },

    // Handle the server response
    $scope.updateBusinessCallback = function(promise) {
        const response = promise;

        if (formHelper.handleResponse(response).isSuccess()) {
            $scope.saving = false;
            messageService.saveAlert();
            // Update merchant info in cache for dashboard
            merchantService.refreshMerchantInfo();

            // Reload the dashboard info
            $rootScope.$broadcast('reloadDashboard');
        } else {
            // An error has occurred, re-enable the button
            $scope.saving = false;
            messageService.error(gettextCatalog.getString('A problem was encountered when saving. Please try again.'));
        }
    };
});




// WEBPACK FOOTER //
// ./src/controllers/business.edit.controller.js